import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./libs/axios";
import VueAxios from "vue-axios";
import "babel-polyfill";
import "lib-flexible";
import "../public/css/font.css";
import { getQueryString } from "@/libs/utils";

// 神策埋点 Start
import sensors from "sa-sdk-javascript";
let serverUrl;
if (location.href.indexOf("//activity.shouqiev.com") > -1) {
  //线上
  serverUrl = "https://gofunsaxcx.shouqiev.com/sa?project=production";
} else {
  //预发布和测试
  serverUrl = "https://gofunsaxcx.shouqiev.com/sa?project=default";
}
sensors.init({
  server_url: serverUrl,
  heatmap: {
    //是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    //需要 JSSDK 版本号大于 1.7
    clickmap: "not_collect", // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    //需要 JSSDK 版本号大于 1.9.1
    scroll_notice_map: "not_collect" // 视区停留事件
  },
  show_log: false, // 设置 true 后会在网页控制台打 logger，会显示发送的数据,设置 false 表示不显示。
  is_track_single_page: true //是否适配单页应用
});
sensors.registerPage({
  platform_type: "H5",
  appName: "H5-Activity"
});
const userId = getQueryString("userId");
sensors.login(userId);
sensors.quick("autoTrack");
// 神策埋点 End

Vue.use(VueAxios, axios); // 引入axios
Vue.config.productionTip = false;

console.log(" ========== process.env ========== ", process.env);

import { Toast } from "vant";
Vue.prototype.$toast = Toast;
Vue.prototype.$sensor = sensors;
window.sensor = sensors;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
